import { nativeScreenshotSupport } from '../../utils/nativeScreenshotSupport';
import { isSuitestreamInstalledApp } from '../Remote/installedAppSelection';

const integrationOf = (device) => {
  const value = device?.integration_data || device?.integrationData || {};
  try { return typeof value === 'string' ? JSON.parse(value) : value; } catch { return {}; }
};

export function resolveScreenshotTarget(nowPlaying, devicesById, liveStates, powerById, nativeNodes = {}) {
  const id = Number(nowPlaying.activeDeviceId || nowPlaying.reportedDeviceId);
  const device = devicesById.get(id);
  if (!device) return { key: 'unresolved', reason: 'Preview unavailable: the current source cannot be identified.' };
  const linkedId = Number(integrationOf(device).remoteTarget?.linkedDeviceId) || null;
  // Step 2 resolves explicit same-site registration links on the server, including other areas.
  const entry = powerById[id];
  const nativeId = linkedId ? (Number(entry?.nativeDeviceId) === linkedId ? linkedId : null)
    : id;
  const live = nativeId ? liveStates[nativeId] : null;
  const support = nativeScreenshotSupport(devicesById.get(nativeId), live, nativeNodes[nativeId]);
  const connected = live?.state?.channels?.native?.connected
    ?? (Number(entry?.nativeDeviceId) === nativeId ? entry?.nativeConnected : false);
  const unverified = !nowPlaying.confirmed;
  const name = device.name || `Device ${id}`;
  const context = nowPlaying.source;
  const app = nowPlaying.activity?.packageName || nowPlaying.activity?.appName || '';
  const key = JSON.stringify([id, nativeId, context, app, unverified, linkedId]);
  const channel = live?.state?.channels?.native;
  const capabilityKey = JSON.stringify([nativeId, channel?.sessionIdentity || channel?.socketId || null,
    channel?.appVersion || null, support.signature]);
  const reason = !nativeId ? 'Preview unavailable: linked native registration is unavailable.'
    : connected !== true || live?.available === false ? 'Preview unavailable: native Android command channel is unavailable.' : support.reason;
  return { key: `${key}:${capabilityKey}`, deviceId: nativeId, name, context, unverified, reason, support, capabilityKey,
    appPackageName: nowPlaying.activity?.packageName || null };
}

export const canShowActivity = (nowPlaying) => !nowPlaying.screenOff && !nowPlaying.screenUnavailable
  && !nowPlaying.sourceAsleep && !nowPlaying.sourceUnavailable;

export const showsSuitestream = (nowPlaying) => canShowActivity(nowPlaying) && Boolean(nowPlaying.activity?.isSuitestream
  || isSuitestreamInstalledApp(nowPlaying.activity));
